import { Container, Skeleton } from "@mui/material";
import { useContext } from "react";
import { FormRegisterPerson } from "./FormRegisterPerson";
import CurrentUserContext from "../../../../contexts/CurrentUserContext";

export const RegisterPerson = () => {
  const { isLoadingUser } = useContext(CurrentUserContext);

  return (
    <Container sx={{ padding: 4 }} maxWidth={"sm"}>
      {isLoadingUser ? <SkeletonRegisterPerson /> : <FormRegisterPerson />}
    </Container>
  );
};

const SkeletonRegisterPerson = () => {
  return (
    <>
      <Skeleton width="100%" height={50} />
      <Skeleton width="100%" height={100} />
      <Skeleton width="100%" height={100} />
      <Skeleton width="100%" height={100} />
    </>
  );
};
